import React from 'react';
import styled from '@emotion/styled';
import { breakpointToContentWidth, breakpointToNarrowContentWidth } from 'ds/components/Layout';
import { BreakpointValue } from 'consts/breakpoints';


interface IWideContentFlag {
  transparentBackground?: boolean;
}

const Wrapper = styled.div<IWideContentFlag>`
  background-image: url("https://front-assets.madlan.co.il/map/localize_loader_3@2x.gif");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 60px 60px;
  background-color:  ${({ theme, transparentBackground }) => transparentBackground ? 'transparent' : theme.colors.neutrals.white};
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  ${({ theme }) =>
    Object.keys(breakpointToNarrowContentWidth)
      .slice(2)
      .map(key =>
        theme.media.showAt({ at: +key as BreakpointValue })`left: calc(${breakpointToContentWidth[key]} - ${breakpointToNarrowContentWidth[key]})`
      )
  }
`;

export const Loader: React.FC<IWideContentFlag> = ({ transparentBackground }) => (
  <Wrapper transparentBackground={transparentBackground}/>
);
